<script setup>
import EmailingAutomationVariableForm from '@frontJs/components/forms/projectManagement/modules/EmailingAutomationVariableForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, emailingAutomationVariable, emailingAutomationVariableTypes } =
    defineProps({
        tenant: {
            type: Object,
            required: false,
        },
        emailingAutomationVariable: {
            type: Object,
            required: false,
        },
        emailingAutomationVariableTypes: {
            type: Array,
            required: true,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="emailingAutomationVariable">
            Mettre à jour une variable d'emailing automatisé #{{
                emailingAutomationVariable.id
            }}
            - Emailings automatisés Modules - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une variable d'emailing automatisé - Emailings automatisés -
            Modules - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="emailingAutomationVariable" :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings automatisés - Mettre à jour une
        variable d'emailing automatisé #{{ emailingAutomationVariable.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings automatisés - Créer une variable
        d'emailing automatisé
    </PageTitle>

    <EmailingAutomationVariableForm
        :emailing-automation-variable="emailingAutomationVariable"
        :emailing-automation-variable-types="emailingAutomationVariableTypes"
        :tenant="tenant"
    />
</template>
